import { render, staticRenderFns } from "./ConfirmTextModal.vue?vue&type=template&id=b00e8200&scoped=true"
import script from "./ConfirmTextModal.vue?vue&type=script&lang=js"
export * from "./ConfirmTextModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmTextModal.vue?vue&type=style&index=0&id=b00e8200&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00e8200",
  null
  
)

export default component.exports